import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { CheckCircle } from 'lucide-react';
import { useCustomerValidation } from '@/components/CustomerValidationProvider';

export const ValidationProgressCard = () => {
  const { 
    selectedCustomer,
    completionPercentage, 
    canComplete,
    totalMandatory,
    completedMandatory 
  } = useCustomerValidation();

  if (!selectedCustomer) return null;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center justify-between text-sm">
          <span className="flex items-center gap-2">
            <CheckCircle className="h-4 w-4" />
            Validation Progress
          </span>
          <Badge variant={canComplete ? "default" : "destructive"} className="text-xs">
            {completedMandatory}/{totalMandatory} Required
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-2">
          <Progress value={completionPercentage} className="w-full h-2" />
          <div className="text-xs text-muted-foreground">
            {completionPercentage.toFixed(1)}% complete
          </div>
          {canComplete && (
            <div className="flex items-center gap-2 text-green-600">
              <CheckCircle className="h-3 w-3" />
              <span className="text-xs">Ready for completion</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};